<table *ngIf="items && items.length; else noData">
    <thead>
        <tr>
            <th> {{ itemsTitle }}</th>
            <th *ngFor="let year of items[0].years">
                {{ year.year }}
            </th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let item of items">
            <td> {{ item.text?.shortLabel }} </td>
            <td *ngFor="let year of item.years">
                <ng-container *ngIf="year.value != null">
                    <span *ngIf="year.type === reportDataType.amount" > {{ year.value | formatAmount }} </span>
                    <span *ngIf="year.type !== reportDataType.amount" > {{ year.value | formatPercent }} </span>
                </ng-container>
            </td>
        </tr>
    </tbody>
</table>

<ng-template #noData>
    <p>{{'invest.eval.noData.summary' | translate}}</p>
</ng-template>
